const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text)
}

const getOnlyFileName = (path) => {
    return path.split('\\').pop().split('/').pop()
}

const formatDate = (val) => {
    if (!val) {
        return ""
    }

    const date = new Date(val)
    return date.toLocaleString('en-US', {
        year: '2-digit',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
    })
}

let sortBy = [
    {prop:'category', dir: 1},
    {prop:'sub', dir: 1},
    {prop:'name', dir: 1}
];

const sorter = (a,b) => {
    //console.log('sorter')
    let i = 0, result = 0;
    while(i < sortBy.length && result === 0) {
        result = sortBy[i].dir*(a[ sortBy[i].prop ] < b[ sortBy[i].prop ] ? -1 : (a[ sortBy[i].prop ] > b[ sortBy[i].prop ] ? 1 : 0));
        i++;
    }
    return result;
}

const shortenThousands = (num) => {
    return Math.abs(num) > 999 ? Math.sign(num)*((Math.abs(num)/1000).toFixed(1)) + 'k' : Math.sign(num)*Math.abs(num)

}

export { 
    copyToClipboard,
    getOnlyFileName,
    formatDate,
    sorter,
    shortenThousands
} 